const SimpleBackgroundParallax = require('simple-background-parallax')

let sbp = new SimpleBackgroundParallax('.inspired-banner')
sbp.start()